"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useScrollBlocker = void 0;
var _react = require("react");
var _browser = require("../utils/browser");
const useScrollBlocker = () => {
  const scroll = (0, _react.useRef)(false);
  const blockScroll = (0, _react.useCallback)(shouldBlock => {
    if ((0, _browser.isSSR)()) return;
    const html = document.documentElement;
    const _document = document,
      body = _document.body;
    if (!(body !== null && body !== void 0 && body.style)) return;

    // block scroll
    if (shouldBlock && !scroll.current) {
      const scrollBarWidth = window.innerWidth - html.clientWidth;
      const bodyPaddingRight = parseInt(window.getComputedStyle(body).getPropertyValue('padding-right')) || 0;
      body.style.position = 'relative';
      body.style.overflow = 'hidden';
      body.style.paddingRight = `${bodyPaddingRight + scrollBarWidth}px`;
      scroll.current = true;
    }

    // allow scroll
    if (!shouldBlock && scroll.current) {
      body.style.position = '';
      body.style.overflow = '';
      body.style.paddingRight = '';
      scroll.current = false;
    }
  }, []);
  return blockScroll;
};
exports.useScrollBlocker = useScrollBlocker;